// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__vj53V","footer":"ReportModalFilter_footer__35RoX"};